import "./Navbar.css";
import resume from "../../Assets/Ayush-Singh-Resume.pdf";

import React, { useState } from "react";
import { FaBars, FaTimes } from "react-icons/fa";

const Navbar = () => {
  const [click, setClick] = useState(false);
  const [color, setColor] = useState(false);
  const handleClick = () => setClick(!click);
  const resumeHandle = () => {
    handleClick();
    window.open(
      `https://drive.google.com/file/d/1HuH_jfgWdOdrj-5RvAtNnCooEsWClehy/view?usp=sharing`
    );
  };

  const changeColor = () => {
    if (window.scrollY >= 10) {
      setColor(true);
    } else {
      setColor(false);
    }
  };

  window.addEventListener("scroll", changeColor);

  return (
    // Home, About Me, Skills, Project, Contact & Resume
    <div className={color ? "header header-bg" : "header"}>
      <h1 className="name">Ayush Singh</h1>
      <ul className={click ? "nav-menu active" : "nav-menu"}>
        <li onClick={handleClick}>
          <a href="#home">Home</a>
        </li>
        <li onClick={handleClick}>
          <a href="#about">About</a>
        </li>
        <li onClick={handleClick}>
          <a href="#skills">Skills</a>
        </li>
        <li onClick={handleClick}>
          <a href="#projects">Projects</a>
        </li>
        <li onClick={handleClick}>
          <a href="#contact">Contact</a>
        </li>
        <li>
          <a
            href={resume}
            onClick={resumeHandle}
            download="fw20_1176-Ayush-Singh-Resume"
            rel="noreferrer"
            target="_blank"
          >
            Resume
          </a>
        </li>
      </ul>
      <div className="hamburger" onClick={handleClick}>
        {click ? (
          <FaTimes size={20} style={{ color: "red" }} />
        ) : (
          <FaBars size={20} style={{ color: "white" }} />
        )}
      </div>
    </div>
  );
};

export default Navbar;
